import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
export var AlertLoadingHeader = function (props) {
    return (_jsxs(_Fragment, { children: [props.seeToast.show &&
                props.showToast(position.topRight, props.seeToast.type, props.seeToast.message, function () {
                    props.setSeeToast({
                        show: false,
                        message: "",
                        type: typeAlert.success,
                    });
                }), _jsx(LoadingAFY, { loading: props.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: props.titleLoading, textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third })] }));
};
